import states from 'states-us';

export function validateAddress(address) {
  const stateAbbreviation = address?.state;
  return !!(
    address &&
    address.addressLine1 &&
    address.city &&
    stateAbbreviation &&
    states.find((state) => state.abbreviation === stateAbbreviation) &&
    address.zip &&
    address.country &&
    address.country.toUpperCase() === 'US'
  );
}
